window.addEventListener('DOMContentLoaded', function() {
  // clear out dynamic modals after they close
  $(document).on('hidden.bs.modal', function(event) {
    if ($(event.target).is('.modal---dynamic')) {
      $(event.target).removeData('bs.modal').html('');
    }
  });
});
